import forEach from "lodash/forEach";
export default (graphComponentRef, nodes, addNeighborNodes) => {
    const edges = new Set();
    if (!graphComponentRef.current)
        return edges;
    nodes.forEach(n => {
        var _a;
        forEach((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph.edgesAt(n).toArray(), e => {
            edges.add(e);
        });
    });
    if (addNeighborNodes) {
        edges.forEach(e => {
            if (nodes instanceof Set) {
                e.sourceNode && nodes.add(e.sourceNode);
                e.targetNode && nodes.add(e.targetNode);
            }
            else {
                e.sourceNode && nodes.push(e.sourceNode);
                e.targetNode && nodes.push(e.targetNode);
            }
        });
    }
    return edges;
};
